import axios from "../../../js/project-axios.js";

const list = () => {
    return axios.get("/appUser/grantApp/list");
};

const revoke = appId => {
    return axios.post("/appUser/grantApp/revoke", appId);
};

export default {
    list,
    revoke
};